import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";

export const createSeo = async (businessId, data) => {
  try {
    let resp = await http.post(`${URL}/seo/${businessId}/create`, data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getSeoByBusiness = async (businessId) => {
  try {
    let resp = await http.get(`${URL}/seo/${businessId}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const updateSeo = async (businessId, seoId, data) => {
  try {
    let resp = await http.put(`${URL}/seo/${businessId}/${seoId}`, data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const deleteSeo = async (businessId, seoId) => {
  try {
    let resp = await http.delete(`${URL}/seo/${businessId}/${seoId}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const checkSubdomain = async (subdomain) => {
  try {
    let resp = await http.get(`${URL}/seo/check-subdomain/${subdomain}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const checkSubdomainByBusiness = async (subdomain) => {
  try {
    let resp = await http.get(`${URL}/seo/by-subdomain/${subdomain}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const allSeos = async () => {
  try {
    let resp = await http.get(`${URL}/seo/all`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const addCustomDomain = async (businessId, domain) => {
  try {
    let resp = await http.post(
      `${URL}/seo/${businessId}/add-domain`,
      { domain }
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const resolveDomain = async (domain) => {
  try {
    const queryDomain = domain || window.location.hostname;
    let resp = await http.get(`${URL}/seo/resolve-domain?domain=${queryDomain}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};